export const PROJECT_DISPLAY_NAME = "Sales Play"
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const IQ_API_BASE_URL = process.env.REACT_APP_ACC_IQ_API_BASE_URL;
export const IQ_API_V2_BASE_URL = process.env.REACT_APP_ACC_IQ_API_V2_BASE_URL;
export const IQ_AUTO_NURTURE_API_BASE_URL = process.env.REACT_APP_ACC_IQ_API_AUTO_NURTURE_BASE_URL;
export const COMPANY_LOGO_BASE_URL = process.env.REACT_APP_COMPANY_LOGO_BASE_URL
export const NEWS_IMAGE_BASE_URL = process.env.REACT_APP_NEWS_IMAGE_BASE_URL
export const MARKET_ESTIMATE_YEAR = "2025"
export const MARKET_FORECAST_YEAR = "2030"
export const JS_CSS_IMG_VERSION = "2.1"
export const WSS_URL = "wss://ws.marketsandmarkets.com/ws"

// export const API_BASE_URL = 'http://127.0.0.1:5000';
// export const BASE_URL = 'http://localhost:3000';